import styled from "styled-components";

export const SectionPanel = styled.div`
  border-radius: 8px;
  border: 1px solid #cfd9e1;
  padding: 24px;
  width: 100%;

  &.activity-card {
    padding: 16px 24px;
  }
`;
